import styled from 'styled-components';
import { colorSchema } from 'utils/style';

export const availableToggleStyles = (Component) => styled(Component)`
  border-radius: 4px;
  width: 32px;
  height: 32px;
  border: 1px solid ${colorSchema('primary500')};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;

  &&:hover {
    cursor: pointer;
    background-color: ${colorSchema('primary100')};
  }

  &&.availableToggle--active:not(:hover) {
    svg {
      path {
        fill: ${colorSchema('accent500')};
      }
    }
  }
`;
